import { combineReducers } from "redux";
import kyc from "../features/admin/kycverification/kyc/Slice";

const kycverification = combineReducers({
  kyc: kyc,
});

export default kycverification;
